import DataTable from 'datatables.net-bs5';
import 'datatables.net-autofill-bs5';
import 'datatables.net-buttons-bs5';
import 'datatables.net-fixedheader-bs5';
import 'datatables.net-responsive-bs5';
import ru from './datatables.ru'

export function pageTableInit() {
  const tables = document.querySelectorAll('[databales]')
  for (let table of tables) {
    const config = getConfig(table)
    new DataTable(table, config)
  }
}

function getConfig(table) {
  const baseSetting = {
    language: ru,
    ordering: true,
    searching: true,
    paging: true,
    scrollCollapse: true,
    bInfo: false
  }

  return baseSetting
}